import { browserHost } from '@/support/browser-host'
import { startSupportPage } from '@/support/support-page'

/* Support page entry (public/pagalba.html): only wiring. The form is in support/support-page.ts and the browser in
   support/browser-host.ts (both tested). */

startSupportPage(browserHost())
